<div [dir]="Direction">
  <app-header />
  <section class="watches-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="section-title">
            {{ currentLang == "ar" ? categoryNameAr : categoryName }}
          </h2>
        </div>
      </div>
      <div class="row text-center mx-auto">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <button class="btn btn-light">
            {{ "translations.allitems" | translate }} {{ items.length }}
          </button>

          <div>
            <button
              class="btn mr-2"
              [ngClass]="{
                'btn-dark': viewMode === 'grid',
                'btn-outline-dark': viewMode !== 'grid'
              }"
              (click)="setViewMode('grid')"
            >
              <fa-icon [icon]="faThLarge"></fa-icon>
            </button>
            <button
              class="btn"
              [ngClass]="{
                'btn-dark': viewMode === 'list',
                'btn-outline-dark': viewMode !== 'list'
              }"
              (click)="setViewMode('list')"
            >
              <fa-icon [icon]="faThList"></fa-icon>
            </button>
          </div>

          <div class="custom-dropdown">
            <button
              class="btn btn-outline-secondary sortings"
              (click)="toggleDropdown()"
            >
              {{
                currentSort === "default"
                  ? ("translations.default_sort" | translate)
                  : currentSort === "popularity"
                  ? ("translations.popularity_sort" | translate)
                  : currentSort === "rating"
                  ? ("translations.rating_sort" | translate)
                  : currentSort === "newest"
                  ? ("translations.newest_sort" | translate)
                  : currentSort === "priceAsc"
                  ? ("translations.price_high_sort" | translate)
                  : currentSort === "priceDesc"
                  ? ("translations.price_low_sort" | translate)
                  : ""
              }}

              <fa-icon [icon]="faAngleDown"></fa-icon>
            </button>

            @if (dropdownOpen) {
            <div class="custom-dropdown-menu">
              <button
                class="custom-dropdown-item"
                [ngClass]="{ active: currentSort === 'Default' }"
                (click)="sortItems('Default')"
              >
                {{ "translations.default_sort" | translate }}
              </button>
              <button
                class="custom-dropdown-item"
                [ngClass]="{ active: currentSort === 'priceAsc' }"
                (click)="sortItems('highToLow')"
              >
                {{ "translations.price_high_sort" | translate }}
              </button>
              <button
                class="custom-dropdown-item"
                [ngClass]="{ active: currentSort === 'priceDesc' }"
                (click)="sortItems('lowToHigh')"
              >
                {{ "translations.price_low_sort" | translate }}
              </button>
            </div>
            }
          </div>
        </div>

        @if(viewMode === 'grid'){ @for (item of items; track $index) {

        <div class="col-md-4 col-sm-6">
          <div class="product-card">
            <div
              class="product-image"
                 [routerLink]="['/item', { id: item.inItemID}]"
            >
              <img
                [src]="apiURL + item.photoPath"
                alt="Item Image"
                *ngIf="item.photoPath"
              />
            </div>
          </div>
          <h3 class="product-title">
            {{ currentLang === "ar" ? item.nameAr : item.name }}
          </h3>
          @if(item.activateWebDiscount){
          <p class="h6 fw-bold mb-0 text-decoration-line-through">
            {{ item.salesPrice }} {{ "translations.currency" | translate }}
          </p>
          <h4>
            {{  (item?.webDiscountAmount || 0) }}
            {{ "translations.currency" | translate }}
          </h4>

          } @else {
          <h4>
            {{ item.salesPrice }} {{ "translations.currency" | translate }}
          </h4>
          }
        </div>
        } } @else { @for (item of items; track $index) {
        <div class="row">
          <div class="col-12 mb-4">
            <div
              class="p-4 border rounded list-view-card flex-column flex-md-row"
            >
              <div
                class="col-12 col-md-4 product-image-container text-center text-md-right mb-3 mb-md-0"
               
                 [routerLink]="['/item', { id: item.inItemID}]"
              >
                <img [src]="apiURL + item.photoPath" alt="Item Image" />
              </div>

              <!-- Product Details (full width on mobile) -->
              <div
                class="col-12 col-md-8 product-details text-center text-md-left"
              
                 [routerLink]="['/item', { id: item.inItemID}]"
              >
                <h3 class="product-title mb-2">
                  {{ currentLang === "ar" ? item.nameAr : item.name }}
                </h3>
                <p class="product-description mb-3">
                  {{ item.description }}
                </p>
                <p class="product-price font-weight-bold">
                  {{
                    currentLang === "ar" ? item.description : item.descriptionAr
                  }}
                </p>
                @if(item.activateWebDiscount){
                <h4>
                  {{ (item?.webDiscountAmount || 0) }}
                  {{ "translations.currency" | translate }}
                </h4>
                <p class="h6 fw-bold mb-0 text-decoration-line-through">
                  {{ item.salesPrice }}
                  {{ "translations.currency" | translate }}
                </p>

                } @else {
                <h4>
                  {{ item.salesPrice }}
                  {{ "translations.currency" | translate }}
                </h4>
                }
                <div
                  class="d-flex justify-content-center justify-content-md-start align-items-center mt-2"
                >
                  <button class="btn btn-outline-secondary btn-sm mr-2">
                    <fa-icon [icon]="faShoppingCart"></fa-icon> إضافة إلى السلة
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        }}
      </div>
    </div>
  </section>
  <app-footer />
</div>
